import React, { Component } from 'react'
import styles from './announcement.styl'
import PropTypes from 'prop-types'
import { get } from 'lodash'

export default class Announcement extends Component {
  static propTypes = {
    announcements: PropTypes.object
  }

  static defaultProps = {
    announcements: {}
  }

  render() {
    const { announcements } = this.props
    const { announcement } = announcements || {}

    return announcements.loaded && !announcements.loading && announcement && announcement.content
      ? <div
        className={styles.container}
      >
        <div className={`${styles.content} ${styles['severity-' + get(announcement, 'severity.type').toLowerCase()]}`}>
          {announcement.content}
        </div>
      </div>
      : null
  }
}

